import { render } from "./UserInit.vue?vue&type=template&id=02d88dbe&scoped=true"
import script from "./UserInit.vue?vue&type=script&lang=js"
export * from "./UserInit.vue?vue&type=script&lang=js"

import "./UserInit.vue?vue&type=style&index=0&id=02d88dbe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02d88dbe"]])

export default __exports__